import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import AdCardMetric from '../../../../../../features/components/AdCardListItem/AdCardMetrics/AdCardMetric'
import AdCardMetricsWrapper from '../../../../../../features/components/AdCardListItem/AdCardMetrics'
import ConversionRelatedMetrics from './ConversionRelatedMetrics'
import { ReactComponent as LikeIcon } from '../../../../../../assets/icons/heart.svg'
import { ReactComponent as ShareIcon } from '../../../../../../assets/icons/share.svg'
import { ReactComponent as FollowIcon } from '../../../../../../assets/icons/follow.svg'

import { renderMetricValue } from '../../../../../../features/components/AdCardListItem/AdCardMetrics/AdCardMetric/renderMetricValue'

import { formatListItemValues } from '../../../../../../features/formatters'

import useStyles from './styles'

function AdCardMetrics({ ad, currencySymbol, showAdditionalMetrics }) {
  const { t } = useTranslation()
  const classes = useStyles()

  const formattedData = useMemo(() => formatListItemValues(ad, { symbol: currencySymbol }), [ad, currencySymbol])

  const {
    impressions,
    cpm,
    reach,
    frequency,
    clicks,
    ctr,
    actions_like: actionsLike,
    actions_post: actionsPost,
    actions_post_reaction: actionsPostReactions,
    spend
  } = formattedData

  return (
    <AdCardMetricsWrapper>
      <AdCardMetric>
        <div>
          {t('Impressions')}
          {showAdditionalMetrics && <span className={classes.metricAdditional}> ({t('CPM')})</span>}
        </div>
        <div>
          {renderMetricValue(impressions)}
          {showAdditionalMetrics && <span className={classes.metricAdditional}> ({renderMetricValue(cpm)})</span>}
        </div>
      </AdCardMetric>

      <AdCardMetric>
        <div>
          {t('Reach')} <span className={classes.metricAdditional}>({t('Frequency')})</span>
        </div>
        <div>
          {renderMetricValue(reach)} <span className={classes.metricAdditional}>({renderMetricValue(frequency)})</span>
        </div>
      </AdCardMetric>

      <AdCardMetric>
        <div>
          {t('Clicks')} <span className={classes.metricAdditional}>({t('CTR')})</span>
        </div>
        <div>
          {renderMetricValue(clicks)} <span className={classes.metricAdditional}>({renderMetricValue(ctr)})</span>
        </div>
      </AdCardMetric>

      <AdCardMetric>
        <div>{t('Engagement')}</div>
        <div className={classes.engagementMetricsWrapper}>
          <div className={classes.engagementItem}>
            <LikeIcon />
            {actionsPostReactions}
          </div>
          <div className={classes.engagementItem}>
            <ShareIcon />
            {actionsPost}
          </div>
          <div className={classes.engagementItem}>
            <FollowIcon />
            {actionsLike}
          </div>
        </div>
      </AdCardMetric>

      <ConversionRelatedMetrics formattedData={formattedData} ad={ad} currencySymbol={currencySymbol} />

      {showAdditionalMetrics && (
        <AdCardMetric>
          <div>{t('Spend')}</div>
          <div>{renderMetricValue(spend)}</div>
        </AdCardMetric>
      )}
    </AdCardMetricsWrapper>
  )
}

export default AdCardMetrics

AdCardMetrics.propTypes = {
  ad: PropTypes.object.isRequired,
  currencySymbol: PropTypes.string.isRequired,
  showAdditionalMetrics: PropTypes.bool,
  showConversionsMetric: PropTypes.bool
}
